import { defineStore } from 'pinia';

export const useUser = defineStore({
  id: 'app-user',
  state: () => ({
    token: '',
    subjectInfo: {},
  }),
  actions: {
  }
});